import {
  B,
  BottomText,
  CodeContainer,
  Container,
  InfoContainer,
  MiddleContainer,
  NavContainer,
  QRContainer,
  QRContainerBorder,
  RewardInfo,
  TopText,
  UserTitle,
  Wrapper,
  ImageContainer
} from './RedeemQR.styled';
import { DisableScroll, EnableScroll } from '@utils/scrollController';
import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import CameraSync_Icon from '@assets/svg/camera_sync.svg';
import CrossIcon from '@assets/svg/match/missing.svg';
import ArtyIcon from '@assets/svg/Badges/arty.svg';
import moment from 'moment';
import ButtonSwipe from '@components/Buttons/ButtonSwipe';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import QR from '@components/SQScan/QR';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import Coin_Icon from '@assets/svg/coin.svg';
import Modal from '@components/Buttons/Modal';
import { SplashCentent } from '@components/SQScan/QRScanScreen.styled';
import { shallow } from 'zustand/shallow';
import StudentThumbnail from '@components/StudentThumbnail';

interface IProps {
  closeScreen?: (closeScreen: boolean) => void;
}

const RedeemQR = (props: IProps) => {
  const { systemSettings, client, settings, setSplash, splash, currentCam, cameraList } = useStore((state) => ({
    systemSettings: state.systemSettings,
    client: state.client,
    settings: state.settings,
    setSplash: state.setSplash,
    splash: state.splash,
    cameraList: state.cameraList,
    currentCam: state.currentCam
  }),
  shallow);
  const [start, setStart] = useState(false);
  const [successState, setSuccessState] = useState(false);
  const [helpText, setHelpText] = useState('state');
  const [error, setError] = useState(null);
  const [checkinError, setCheckinError] = useState(null);
  const [rewards, setRewards] = useState(null);
  const [rewardId, setRewardId] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const i18n = useI18n();
  const qrRef = useRef(null)
  const cameraDelayTimer = useRef(null);
  const splashRef = useRef(null)

  useEffect(() => {
    getRewards();
  }, []);

  const HandleRedeem = async (code: string): Promise<boolean> => {
    let codeCheck = await CheckCode(code);

    return new Promise(async (resolve, reject) => {
      if (codeCheck.length > 0 && codeCheck[0].result === true) {
        let userinfo = await db.getUserDetails(codeCheck[0].username, null);
        if (userinfo.length > 0) setUserInfo(userinfo[0]);
        setRewardId(codeCheck[0].reward_id);
        setSuccessState(true);
        resolve(true);
      } else {
        setHelpText(code);
        setCheckinError(true);
        resolve(false);
      }
    });
  };

  let language = systemSettings.find((s) => s.APP_Setting_ID === 16);
  let reward = rewards?.find((r) => r.id === rewardId);
  const getRewards = () => {
    db.GetRewards(language.value).then((data) => {
      setRewards(data);
    });
  };

  const CheckCode = async (code: string) => {
    let codeCheck = await db.Redeem_Reward(client.UserName, code);
    return codeCheck;
  };

  function handleCamera() {
    if ((moment().unix() > cameraDelayTimer.current + 2) || cameraDelayTimer.current === null) {
      setSplash(true)
      setTimeout(function () {
        splashRef?.current?.handleClose();
      }, 4000);
      cameraDelayTimer.current = moment().unix()
      qrRef.current.swapCamera()
    }
  }

  const getComponent = () => {
    if (successState) {
      return (
        <Container>
          <InfoContainer>
            {userInfo ? (
              <>
                <ImageContainer>
                  <StudentThumbnail bigFont='4em' font={"4em"} regView={true} name={settings.DEMO ? "Demo Student" : userInfo.displayname} src={userInfo.username} />
                </ImageContainer>
                <UserTitle>{settings.DEMO ? "Demo Student" : userInfo.displayname}</UserTitle>
              </>
            ) : null}
            {reward ? (
              <>
                <RewardInfo>
                  <h2>{i18n.t('redeemed')}</h2>
                  <span>{reward.title}</span>
                  <p>
                    {reward.cost} <Coin_Icon />
                  </p>
                  <span>{reward.description}</span>
                </RewardInfo>
              </>
            ) : null}
          </InfoContainer>

          <B onClick={() => setSuccessState(false)}>{i18n.t('scan-another')}</B>
        </Container>
      );
    } else if (checkinError) {
      return (
        <Container>
          <TopText>
            <span>{i18n.t('qr-code-invalid')}</span>
          </TopText>
          <MiddleContainer>
            <button onClick={() => setCheckinError(null)}>{i18n.t('retry')}</button>
          </MiddleContainer>
        </Container>
      );
    } else if (error !== null) {
      if (error === 1) {
        return (
          <Container>
            <TopText>
              <span>{i18n.t('qr-kamera-1')}</span>
            </TopText>
          </Container>
        );
      } else if (error === 2) {
        return (
          <Container>
            <TopText>
              <span>{i18n.t('qr-kamera-2')}</span>
            </TopText>
          </Container>
        );
      } else {
        return (
          <Container>
            <TopText>
              <span>{i18n.t('qr-kamera-3')}</span>
            </TopText>
          </Container>
        );
      }
    } else if (checkinError === null && !successState) {
      return (
        <>{splash ? <Modal onClose={setSplash} ref={splashRef} fadeTop={true} Placement={{ height: "auto", width: "100vw", top: "20px", left: "0" }}>
          <SplashCentent>
            <span>Skifter til kamera {currentCam + 1} / {cameraList.length}</span>
          </SplashCentent>
        </Modal > : null
        }
          <Container>
            <TopText>
              <span>{i18n.t('scan-qr-code')}</span>
            </TopText>
            <NavContainer>
                <CameraSync_Icon onClick={() => handleCamera()} />
            </NavContainer>
            <QRContainer>
              <QRContainerBorder />
              <QR GetInformation={HandleRedeem} ref={qrRef} returnResult={HandleRedeem} error={setError} />
            </QRContainer>
            <BottomText>
              <p></p>
            </BottomText>
          </Container></>
      );
    } else {
      return (
        <Container>
          <RainbowLoader />
        </Container>
      );
    }
  };

  return <Wrapper start={start}>{getComponent()}</Wrapper>;
};

export default RedeemQR;
